// Time-boxed launch pricing banner.
// Shows a small scarcity note under every prominent ₹2,800 price display
// until 31 Aug (11:59 PM IST). After that the note auto-hides and the
// price stays as-is until you swap the numbers.

// IST offset = UTC+5:30. 1 Sept 00:00 IST = 31 Aug 18:30 UTC.
const PROMO_END_UTC = new Date("2026-08-31T18:30:00Z");

export function isPromoActive(now = new Date()) {
  return now < PROMO_END_UTC;
}

export const PROMO_LINE = "Valid till 31 Aug · Price increases to ₹7,999 from 1 Sept";

export function PromoNote({ className = "", align = "center" }) {
  if (!isPromoActive()) return null;
  const alignCls = align === "left" ? "text-left" : "text-center";
  return (
    <p
      data-testid="promo-note"
      className={`text-[10px] sm:text-[11px] font-mono uppercase tracking-widest text-[#FF9F5A] ${alignCls} ${className}`}
    >
      {PROMO_LINE}
    </p>
  );
}
